var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from "react";
import { Select } from "@irati/ui/src/FormItem";
import Validation from "@irati/utils/validation";
import getSupportedLocale, { makeOptions } from "@irati/utils/lang/helpers/getSupportedLocale";
import { injectIntl } from "@irati/utils/lang";
var schema = function (formatMessage) { return Validation.string(formatMessage({ id: "platform.userLocale.validation" })); };
var Lastname = /** @class */ (function (_super) {
    __extends(Lastname, _super);
    function Lastname() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.options = makeOptions();
        return _this;
    }
    Lastname.prototype.render = function () {
        var _a = this.props, formatMessage = _a.formatMessage, value = _a.value, props = __rest(_a, ["formatMessage", "value"]);
        var formattedValue = getSupportedLocale(value);
        return (React.createElement(Select, __assign({ name: "user.locale", label: formatMessage({ id: "platform.fields.locale.label" }), value: formattedValue, options: this.options, isClearable: false, validation: schema(formatMessage) }, props)));
    };
    return Lastname;
}(PureComponent));
export default injectIntl(Lastname);
